// src/core/api/employeeApi.js
import { axiosClient } from "./axiosClient";

/* Employees CRUD */

export const getEmployees = (params = {}) =>
  axiosClient.get("/employees/", { params });

export const getEmployee = (id) =>
  axiosClient.get(`/employees/${id}/`);

export const createEmployee = (formData) =>
  axiosClient.post("/employees/", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const updateEmployee = (id, formData) =>
  axiosClient.patch(`/employees/${id}/`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const deleteEmployee = (id) =>
  axiosClient.delete(`/employees/${id}/`);

/* Letters */

export const downloadOfferLetter = (id) =>
  axiosClient.get(`/employees/${id}/offer/`, {
    responseType: "blob",
  });

export const downloadExperienceLetter = (id) =>
  axiosClient.get(`/employees/${id}/experience/`, {
    responseType: "blob",
  });
